{
    "releaseNotes": {
        "tabName": "Kiadási előzmények",
        "accordianHeading": "Kiadás me@eon V<version>",
        "accordianMyHelpHeading": "Kiadás MyHelp (me@eon) V<version>",
        "accordianMyHelpNewHeading": "Kiadás MyHelp V<version>",
        "whatsNew": "Újdonságok",
        "tipsAndTricks": "Tippek és trükkök",
        "faq": "GYIK"
    },
    "ourTeam": {
        "tabName": "Csapatunk",
        "keyMembers": "Kulcstagok"
    },
    "featureRoadmap": {
        "tabName": "Funkciók és ütemterv"
    }
}